import Axios from "axios";
import { headers, SALES_SCHEDULING } from "../../config";

export function getPumps() {
    return Axios.get(`${SALES_SCHEDULING}/pumps`, { headers: headers() });
}